import React from "react";
import styles from "./index.module.scss";

export default function Balloon({ point }) {
  const adr = point.ADR ?? point.address ?? point["~ADR"];
  const time = point.WORK_TIME ?? point.workingHours ?? point.workTime;
  return (
    <div className={styles.BalloonPoint}>
      {adr && <span dangerouslySetInnerHTML={{ __html: adr }} />}
      {time && (
        <>
          <br />
          {time}
        </>
      )}
    </div>
  );
}
